<template>
    <div class="container mt-4">
      <h2 class="text-center mb-4">船坞信息</h2>
      <div class="row">
        <div v-for="grid in grids" :key="grid.GridId" class="col-md-4 mb-4">
          <div class="card text-white" >
            <div class="card-header text-center">
              <h3>{{ grid.GridName }}</h3>
            </div>
            <div class="card-body">
              <p><strong>网格 ID:</strong> {{ grid.GridId }}</p>
              <p><strong>存船位置:</strong> {{ formatPosition(grid.GridSavePosition) }}</p>
              <p><strong>方块数:</strong> {{ grid.NumberOfBlocks }}</p>
              <p><strong>PCU:</strong> {{ grid.GridPcu }}</p>
              <!-- <p><strong>市场价值:</strong> {{ grid.MarketValue }}</p> -->
              <p><strong>完整度:</strong> {{ (grid.GridBuiltPercent * 100).toFixed(2) }}%</p>
              <hr>
              <h5>方块类型数量</h5>
              <p><strong>反应堆数量:</strong> {{ grid.BlockTypeCount.Reactors }}</p>
              <p><strong>炮塔数量:</strong> {{ grid.BlockTypeCount.Turrets }}</p>
              <p><strong>静态枪数量:</strong> {{ grid.BlockTypeCount.StaticGuns }}</p>
              <p><strong>精炼厂数量:</strong> {{ grid.BlockTypeCount.Refineries }}</p>
              <p><strong>组装机数量:</strong> {{ grid.BlockTypeCount.Assemblers }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from '../api/axios';
  
  export default {
    data() {
      return {
        grids: [],
      };
    },
    methods: {
      fetchHangarData() {
        axios.get('/myhangar')
          .then(response => {
            this.grids = response.data.Grids;
          })
          .catch(error => {
            console.error('获取挂舱数据时出错:', error);
          });
      },
      formatPosition(position) {
        return `X: ${position.X.toFixed(2)}, Y: ${position.Y.toFixed(2)}, Z: ${position.Z.toFixed(2)}`;
      }
    },
    mounted() {
      this.fetchHangarData();
    },
  };
  </script>
  
  <style scoped>
  .container {
    max-width: 1200px;
  }
/*   
  h2 {
    color: #343a40;
    background:none;
  }
   */
  h3 {
    color: #ffffff;
    font-size: 1.2rem;
    background:none;
    margin-bottom: 0;
  }

  .card-header {
    background-color:#2A013466;

  }
  
  .card-body {
    font-size: 0.9rem;
    background: none !important;
  }
  
  .card {
    
    background: linear-gradient(315deg, #01010101 0%, #01010191 100%) !important;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  </style>
  